module.exports = __webpack_public_path__ + "static/media/zan-now.1cb037dd.png";